<template>
  <div v-if="!hideEmpty || tableData.length > 0" style="margin-top: 50px">
    <base-material-card :renderCard="card" color="secondary" icon="mdi-cart-outline" :title="title">
      <v-row no-gutters>
        <v-col v-if="mode === 'affiliazioni'" class="d-flex justify-center">
          <my-datepicker v-model="validityDate" @input="loadTable" :label="$t('valid_at')" required="true" />
        </v-col>
        <v-col v-if="mode === 'ALL'" class="d-flex justify-center">
          <my-datepicker v-model="dateInz" @input="loadTable" :label="$t('date_from')" required="true" />
          <my-datepicker v-model="dateEnd" @input="loadTable" :label="$t('date_to')" required="true" />
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <DataTables @printTicket="printTicket" @printRicevuta="printRicevuta" @printTessera="printTessera"
            @printDiploma="printDiploma" @evadeOrder="evadeOrder" @approvePayment="approvePayment"
            @startOnlinePayment="startOnlinePayment" @rejectPayment="rejectPayment" @showOrder="showOrder"
            :headers="headers" :table-data="tableData" />
        </v-col>
      </v-row>
    </base-material-card>
    <view-order @isDeleted="loadTable" @isUpdated="loadTable" ref="viewOrderDialog"></view-order>
  </div>
</template>

<script>
import DataTables from "@/components/base/DataTables.vue";
import MyDatepicker from "@/components/base/MyDatepicker.vue";
import viewOrder from "@/widget/viewOrder.vue";
import Swal from "sweetalert2";
const _ = this;
export default {
  name: "list-ordini",
  components: {
    DataTables,
    viewOrder,
    MyDatepicker,
  },
  props: {
    card: false,
    hideEmpty: false,
    mode: null,
    masterId: null,
    idEvento: null,
    method: null,
  },
  data() {
    return {
      title: null,
      isFetching: true,
      headers: [],
      validityDate: new Date(),
      dateInz: this.getInzDate(),
      dateEnd: new Date(),
      tableData: [],
      RBAC_APPROVE: false,
      RBAC_EVADE: false,
    };
  },
  watch: {
    masterId: function (newVal, oldVal) {
      // watch it
      if (newVal) this.loadTable();
    },
    idEvento: function (newVal, oldVal) {
      // watch it
      if (newVal) this.loadTable();
    },
  },
  mounted() {
    this.RBAC_APPROVE = this.checkUserRole("order", "APPROVE_PAYMENT");
    this.RBAC_EVADE = this.checkUserRole("order", "EVADE");
    this.loadTable();
  },
  methods: {
    getInzDate() {
      var d = new Date();
      d.setDate(d.getDate() - 7);
      return d;
    },
    showOrder(item) {
      this.$refs.viewOrderDialog.open(item.orderId);
    },
    printTicket(item) {
      this.$documentViewer.documentViewerRsp.docUrl = item.ticketUrl;
      //window.open(item.ticketUrl);
    },
    printRicevuta(item) {
      this.$documentViewer.documentViewerRsp.docUrl = item.ricevutaUrl;
      //window.open(item.ticketUrl);
    },
    printTessera(item) {
      this.$documentViewer.documentViewerRsp.docUrl = item.tesseraUrl;
      //window.open(item.ticketUrl);
    },
    printDiploma(item) {
      this.$documentViewer.documentViewerRsp.docUrl = item.diplomaUrl;
      //window.open(item.ticketUrl);
    },
    approvePayment(item) {
      const _ = this;
      this.chiamataAxios(
        "POST",
        "/auth/portal/approveOrderPayment/" + item.orderId,
        { dialogLoader: true, msg: "always" }
      ).then((response) => {
        _.loadTable();
      });
    },
    startOnlinePayment(item) {
      const _ = this;
      this.chiamataAxios(
        "POST",
        "/auth/portal/newOnlinePaymentOrder/" + item.orderId,
      ).then((response) => {
        if (response.payUrl) {
          Swal.fire({
            title: _.$t("redirect_to_external_site"),
            html: _.$t("for_complete_the_payment_operation"),
          }).then((result) => {
            window.open(response.payUrl);
          });
        }
      });
    },
    evadeOrder(item) {
      const _ = this;
      this.chiamataAxios("POST", "/auth/portal/setOrderEvaso/" + item.orderId, {
        body: {
          all: true,
        },
        dialogLoader: true,
        msg: "always",
      }).then((response) => {
        _.loadTable();
      });
    },
    rejectPayment(item) {
      const _ = this;
      this.chiamataAxios("DELETE", "/auth/portal/cancelOrder/" + item.orderId, {
        dialogLoader: true,
        msg: "always",
      }).then((response) => {
        _.loadTable();
      });
    },
    loadTable() {
      const _ = this;
      _.tableData = [];
      let method = "GET";
      let filter = {};

      if (!_.mode || _.mode === "USER") {
        _.title = _.$t("orders");
        _.headers = [
          { value: "date", text: this.$t("date"), type: "date" },
          {
            value: "orderIdWithImage",
            text: this.$t("order_code"),
            type: "imageText",
            height: 20,
          },
          { value: "type", text: this.$t("type"), type: "string" },
          { value: "text", text: this.$t("description"), type: "html" },
          { value: "statusDex", text: this.$t("status"), type: "html" },
          { value: "totale", text: this.$t("total"), type: "valuta" },
          { value: "options", text: this.$t("options"), type: "buttons" },
        ];
      } else if (!_.mode || _.mode === "2pay") {
        _.title = _.$t("orders_waiting_payment");
        method = "POST";
        filter.mode = _.mode;
        _.headers = [
          { value: "date", text: this.$t("date"), type: "date" },
          {
            value: "orderIdWithImage",
            text: this.$t("order_code"),
            type: "imageText",
            height: 20,
          },
          { value: "type", text: this.$t("type"), type: "string" },
          { value: "text", text: this.$t("description"), type: "html" },
          { value: "statusDex", text: this.$t("status"), type: "html" },
          { value: "totale", text: this.$t("total"), type: "valuta" },
          { value: "options", text: this.$t("options"), type: "buttons" },
        ];
      }
      else if (_.mode == "ALL") {
        method = "POST";
        filter.mode = _.mode;
        filter.dateInz = _.dateInz;
        filter.dateEnd = _.dateEnd;
        _.title = _.$t("orders");
        _.headers = [
          { value: "date", text: this.$t("date"), type: "date" },
          { value: "orderId", text: this.$t("order_number"), type: "string" },
          { value: "orderCode", text: this.$t("order_code"), type: "string" },
          { value: "type", text: this.$t("type"), type: "string" },
          { value: "text", text: this.$t("description"), type: "html" },
          { value: "statusDex", text: this.$t("status"), type: "html" },
          { value: "totale", text: this.$t("total"), type: "valuta" },
          {
            value: "contabilizzato",
            text: this.$t("is_contabilized"),
            type: "icons",
          },
          { value: "options", text: this.$t("options"), type: "buttons" },
        ];
      } else if (_.mode === "evento") {
        _.title = _.$t("event_subscriber");
        method = "POST";
        filter.mode = _.mode;
        filter.idEvento = _.idEvento;
        _.headers = [
          { value: "date", text: this.$t("date"), type: "date" },
          { value: "orderId", text: this.$t("order_number"), type: "string" },
          { value: "fullName", text: this.$t("name"), type: "string" },
          { value: "text", text: this.$t("description"), type: "html" },
          { value: "shortProdotti", text: this.$t("products"), type: "html" },
          { value: "statusDex", text: this.$t("status"), type: "html" },
          { value: "certIcon", text: this.$t("certificate"), type: "icons" },
          { value: "totale", text: this.$t("total"), type: "valuta" },
          { value: "options", text: this.$t("options"), type: "buttons" },
        ];
      } else if (_.mode === "affiliazioni") {
        _.title = _.$t("view_affiliations");
        method = "POST";
        filter.mode = _.mode;
        filter.validityDate = _.validityDate;
        _.headers = [
          { value: "date", text: this.$t("date"), type: "date" },
          { value: "orderId", text: this.$t("order_number"), type: "string" },
          { value: "orderCode", text: this.$t("order_code"), type: "string" },
          { value: "asdRagSoc", text: this.$t("ragSoc"), type: "string" },
          { value: "text", text: this.$t("description"), type: "html" },
          { value: "statusDex", text: this.$t("status"), type: "html" },
          { value: "totale", text: this.$t("total"), type: "valuta" },
          { value: "options", text: this.$t("options"), type: "buttons" },
        ];
      } else if (_.mode === "2approve") {
        _.title = _.$t("order_2_approve");
        method = "POST";
        filter.mode = _.mode;
        _.headers = [
          { value: "date", text: this.$t("date"), type: "date" },
          { value: "orderId", text: this.$t("order_number"), type: "string" },
          { value: "orderCode", text: this.$t("order_code"), type: "string" },
          { value: "fullName", text: this.$t("name"), type: "string" },
          { value: "text", text: this.$t("description"), type: "html" },
          { value: "shortProdotti", text: this.$t("products"), type: "html" },
          { value: "statusDex", text: this.$t("status"), type: "html" },
          { value: "totale", text: this.$t("total"), type: "valuta" },
          { value: "options", text: this.$t("options"), type: "buttons" },
        ];
      } else if (_.mode === "2evade") {
        _.title = _.$t("order_2_evade");
        method = "POST";
        filter.mode = _.mode;
        _.headers = [
          { value: "date", text: this.$t("date"), type: "date" },
          { value: "orderId", text: this.$t("order_number"), type: "string" },
          { value: "orderCode", text: this.$t("order_code"), type: "string" },
          { value: "fullName", text: this.$t("name"), type: "string" },
          { value: "text", text: this.$t("description"), type: "html" },
          { value: "shortProdotti", text: this.$t("products"), type: "html" },
          { value: "statusDex", text: this.$t("status"), type: "html" },
          { value: "totale", text: this.$t("total"), type: "valuta" },
          {
            value: "qtaConDex",
            text: this.$t("quantity"),
            type: "string",
          },
          {
            value: "qtaConPerc",
            text: this.$t("quantity"),
            type: "progressBar",
          },

          { value: "options", text: this.$t("options"), type: "buttons" },
        ];
      }
      let url = "/auth/portal/listOrder";
      if (_.masterId && _.mode !== "ALL") url += "/" + _.masterId;
      if (_.mode === "USER") url += "?showEnte=true";
      this.chiamataAxios(method, url, { body: filter }).then((response) => {
        let data = response.data.map(function (item) {
          item.orderIdWithImage = {
            image: item.badge,
            text: item.orderId,
          };
          let statusClass = "warning--text";
          if (item.status <= 0) statusClass = "error--text";
          if (item.status >= 4) statusClass = "success--text";

          if (_.mode === "evento") {
            if (item.certificato.validato && !item.certificato.scaduto)
              item.certIcon = [{ icon: "mdi-file-check-outline", color: "green" }];
            else if (!item.certificato.validato && item.certificato.caricato && !item.certificato.scaduto)
              item.certIcon = [
                { icon: "mdi-file-question-outline", color: "blue" },
              ];
            else
              item.certIcon = [{ icon: "mdi-file-remove-outline", color: "red" }];

          }

          //item.url = _.authorizeLink(item.url);
          if (item.contabilizzato) {
            item.contabilizzato = [{ icon: "mdi-cash-check", color: "green" }];
          }
          if (item.asdCode && item.asdCode !== "")
            item.fullName =
              (item.asdRagSoc ? item.asdRagSoc : item.asdCode) +
              " (" +
              item.fullName +
              ")";
          item.options = [];
          if (!item.extOrder)
            item.options.push({
              icon: "mdi-magnify",
              color: "primary",
              text: _.$t("view_order"),
              function: "showOrder",
            });
          if (item.ticketUrl) {
            item.options.push({
              icon: "mdi-ticket",
              color: "success",
              text: _.$t("print_ticket_event"),
              function: "printTicket",
            });
          }
          if (item.ricevutaUrl) {
            item.options.push({
              icon: "mdi-piggy-bank-outline",
              color: "success",
              text: _.$t("receipt"),
              function: "printRicevuta",
            });
          }
          if (item.tesseraUrl) {
            item.options.push({
              icon: "mdi-card-account-details-outline",
              color: "success",
              text: _.$t("card"),
              function: "printTessera",
            });
          }
          if (item.diplomaUrl) {
            item.options.push({
              icon: "mdi-certificate-outline",
              color: "success",
              text: _.$t("diploma"),
              function: "printDiploma",
            });
          }
          if (_.mode === "2evade") {
            item.qtaConPerc = (item.totQtaCon * 100) / item.totQtaRic;
            item.qtaConDex = item.totQtaCon + "/" + item.totQtaRic;
            if (_.RBAC_EVADE && item.canEvade)
              item.options.push({
                icon: "mdi-cart-arrow-up",
                function: "evadeOrder",
                text: _.$t("evade_order"),
                color: "success",
              });
          }
          if (_.mode === "2approve" && _.RBAC_APPROVE) {
            if (item.canApprove)
              item.options.push({
                icon: "mdi-thumb-up-outline",
                function: "approvePayment",
                text: _.$t("approve"),
                color: "orange",
              });
            if (item.canReject)
              item.options.push({
                icon: "mdi-thumb-down-outline",
                function: "rejectPayment",
                text: _.$t("reject"),
                color: "orange",
              });
          }
          if ((_.mode === "USER" || _.mode === "2pay") && item.toPayOnline) {
            item.options.push({
              icon: "mdi-cash-clock",
              function: "startOnlinePayment",
              text: _.$t("start_online_payment"),
              color: "green",
            });

          }

          item.statusDex =
            "<h4 class=" + statusClass + ">" + item.statusDex + "</h4>";

          return item;
        });
        _.tableData = data;
      });
    },
  },
};
</script>
